import { useEffect, useRef } from "react";

import { BOT_EMBED_STYLES } from "./styles";

const STYLE_ID = "botbuddy-bot-embed-styles";

const useEmbeddedStyles = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    const currentElement = rootRef.current;

    if (!currentElement) {
      return;
    }

    const rootNode = currentElement.getRootNode();
    const hasShadowRoot =
      typeof ShadowRoot !== "undefined" && rootNode instanceof ShadowRoot;
    const target = hasShadowRoot ? rootNode : document.head;
    const existingStyle = hasShadowRoot
      ? rootNode.querySelector(`#${STYLE_ID}`)
      : document.getElementById(STYLE_ID);

    if (existingStyle) {
      return;
    }

    const styleElement = document.createElement("style");
    styleElement.id = STYLE_ID;
    styleElement.textContent = BOT_EMBED_STYLES;
    target.appendChild(styleElement);
  }, []);

  return rootRef;
};

export default useEmbeddedStyles;
